export default __webpack_public_path__ + "static/media/sum1.7e882ed1.png";